export const STATE_LOADING = {
  SUCCESS: 1,
  PENDING: 2,
  FAILED: 3,
};
